<template>
    <div class="paper">
        <div class="paper-box">
            <div>订单编号：{{datas.number}}</div>
            <div class="base-info">
                <div>客户姓名：{{datas.clientname}}</div>
                <div>联系方式：{{datas.mobile}}</div>
                <div>客户类型：{{datas.clienttypename}}</div>
            </div>
            <table
                border="0"
                cellspacing="0"
            >
                <tr>
                    <th>气瓶类型</th>
                    <th>气瓶规格</th>
                    <th>总数量</th>
                    <th>总重量</th>
                    <th>总价</th>
                    <th>备注</th>
                </tr>
                <tr
                    v-for="(item, index) in datas.goods"
                    :key="index"
                >
                    <td>{{item.goodsname}}</td>
                    <td>{{item.specification}}</td>
                    <td>{{item.amount}}</td>
                    <td>{{item.weight}}</td>
                    <td>{{item.money}}</td>
                    <td>{{item.remark}}</td>
                </tr>
            </table>
            <div class="footer-info">
                <div>订单总重量: {{datas.sumweight}}千克</div>
                <div>订单总金额: {{datas.summoney}}元</div>
                <div>欠款金额: {{datas.arrears}}元</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            datas: {}
        }
    },
    created() {

    },
    mounted() {
        this.initPrintData()
    },
    props: {
        oid: {
            default: -1
        },
        printCount: {
            default: 1
        }
    },
    watch: {

    },
    methods: {
        async initPrintData() {
            let res = await this.$util.request(this.$ctrl.order.detail, {
                id: this.oid
            })
            this.datas = res.data
            setTimeout(() => {
                for (let t = 0; t < this.printCount; t++) {
                    window.print()
                }
                this.$emit('finish', null)
            }, 1000);
        }
    }
}
</script>

<style scoped lang="less">
.paper {
    width: 100vw;
    min-height: 100vh;
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    background-color: white;
    .paper-box {
        margin-top: 1cm;
        padding-right: 1cm;
        width: 15cm;
        height: 6cm;
        border-right: 1px dashed black;
        color: black;
        font-size: 14px;
        font-weight: bold;
        line-height: 24px;

        .base-info {
            display: grid;
            grid-template-rows: repeat(2, 50%);
            grid-template-columns: repeat(3, 33.33%);
        }

        table {
            width: 100%;
            margin: 8px 0px;

            & tr:last-child :nth-child(n) {
                border-bottom: 1px solid black;
            }

            & th {
                background-color: white;
                color: black;
            }

            & th,
            & td {
                border-top: 1px solid black;
                border-left: 1px solid black;
                margin: 0px;
                text-align: center;

                &:last-child {
                    border-right: 1px solid black;
                }
            }
        }

        .footer-info {
            display: grid;
            grid-template-columns: repeat(3, 33.33%);
            text-align: center;
        }
    }
}
</style>
